/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class lodgemembershipsummary extends IceEntity {
  key: string = "";
  date_of_summary: any = NaN;
  charter_number: string = "";
  starting_date: any = NaN;
  ending_date: any = NaN;
  functioning_status: string = "";
  number_of_members: number = 0;
  active_members: number = 0;
  meeting_location: string = "";
  activities: string = "";
  other_activities: string = "";
  transfer_name1: string = "";
  transfer_to_charter1: string = "";
  transfer_effective_date1: any = NaN;
  transfer_name2: string = "";
  transfer_to_charter2: string = "";
  transfer_effective_date2: any = NaN;
  remit_period: string = "";
  remitted_amount: number = 0.0;
  suggestions: string = "";
  organization_name: string = "";
  street1: string = "";
  street2: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  province: string = "";
  country_id: string = "";

  constructor(cpy?: lodgemembershipsummary) {
    super();

    if (cpy != null) {
      // skip the primary key
      this.date_of_summary = cpy.date_of_summary;
      this.charter_number = cpy.charter_number;
      this.starting_date = cpy.starting_date;
      this.ending_date = cpy.ending_date;
      this.functioning_status = cpy.functioning_status;
      this.number_of_members = cpy.number_of_members;
      this.active_members = cpy.active_members;
      this.meeting_location = cpy.meeting_location;
      this.activities = cpy.activities;
      this.other_activities = cpy.other_activities;
      this.transfer_name1 = cpy.transfer_name1;
      this.transfer_to_charter1 = cpy.transfer_to_charter1;
      this.transfer_effective_date1 = cpy.transfer_effective_date1;
      this.transfer_name2 = cpy.transfer_name2;
      this.transfer_to_charter2 = cpy.transfer_to_charter2;
      this.transfer_effective_date2 = cpy.transfer_effective_date2;
      this.remit_period = cpy.remit_period;
      this.remitted_amount = cpy.remitted_amount;
      this.suggestions = cpy.suggestions;
      this.organization_name = cpy.organization_name;
      this.street1 = cpy.street1;
      this.street2 = cpy.street2;
      this.city = cpy.city;
      this.state_id = cpy.state_id;
      this.postal_code = cpy.postal_code;
      this.province = cpy.province;
      this.country_id = cpy.country_id;
    }
  }

  public gettablename(): string {
    return "LODGE_MEMBERSHIP_SUMMARY";
  }
}
